import clsx from 'clsx';
import React, {
  ComponentPropsWithoutRef,
  MouseEvent,
  TouchEvent,
  useState,
} from 'react';

interface CardHoloEffectProps extends ComponentPropsWithoutRef<'div'> {
  animated?: boolean;
}

const useCardHoloEffect = (): any => {
  const [_, setIsTouch] = useState<boolean>(false);
  const [style, setStyle] = useState<React.CSSProperties | any>({});

  let x: ReturnType<typeof setTimeout>;

  const handleMouseMove = (
    e: MouseEvent<HTMLDivElement> | TouchEvent<HTMLDivElement>
  ): void => {
    const pos: [number, number] = [0, 0];
    if (e.type === 'touchmove') {
      return;
      // setIsTouch(true);
      // const touch = (e as TouchEvent<HTMLDivElement>).touches[0];
      // pos[0] = touch.clientX;
      // pos[1] = touch.clientY;
    } else {
      const mouseEvent = e as MouseEvent<HTMLDivElement>;
      pos[0] = mouseEvent.nativeEvent.offsetX;
      pos[1] = mouseEvent.nativeEvent.offsetY;
    }
    const l = pos[0];
    const t = pos[1];
    const h = (e.target as HTMLDivElement).clientHeight;
    const w = (e.target as HTMLDivElement).clientWidth;
    const px = Math.abs(Math.floor((100 / w) * l) - 100);
    const py = Math.abs(Math.floor((100 / h) * t) - 100);
    const pa = 50 - px + (50 - py);
    const lp = 50 + (px - 50) / 1.5;
    const tp = 50 + (py - 50) / 1.5;
    const pxSpark = 50 + (px - 50) / 7;
    const pySpark = 50 + (py - 50) / 7;
    const pOpc = 20 + Math.abs(pa) * 1.5;
    // const ty = ((tp - 50) / 2) * -1;
    // const tx = ((lp - 50) / 1.5) * 0.5;

    const gradPos = `background-position: ${lp}% ${tp}%`;
    const sprkPos = `background-position: ${pxSpark}% ${pySpark}%;`;
    const opc = `opacity: ${pOpc / 100};`;

    // const newStyle = {
    //   transform: `rotateX(${ty}deg) rotateY(${tx}deg)`,
    //   // transition: 'all 0.2s',
    // };
    // setStyle(newStyle);

    const styleTag = document.querySelector('.hover');

    if (styleTag) {
      styleTag.innerHTML = `
        .card:hover:before { ${gradPos} }  /* gradient */
        .card:hover:after { ${sprkPos} ${opc} }   /* sparkles */
      `;
    }

    clearTimeout(x);
  };

  const handleMouseLeave = (): void => {
    setIsTouch(false);
    setTimeout(() => {
      setStyle({
        transform: `rotateX(${0}deg) rotateY(${0}deg)`,
        // transition: 'all 0.2s',
      });
    }, 50);

    x = setTimeout(() => {
      // e.target.classList.add("animated")
      // Define behavior for when the timeout completes
      // For example, setIsAnimated(true);
    }, 2500);
  };

  return { handleMouseMove, handleMouseLeave, style };
};

const CardHoloEffect: React.FC<CardHoloEffectProps> = ({
  children,
  className,
  animated = true,
}) => {
  const { handleMouseMove, handleMouseLeave, style } = useCardHoloEffect();

  return (
    <>
      <div
        style={style}
        className={clsx(
          'cardHolo card cursor-hand',
          className,
          animated && 'animated'
        )}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onTouchMove={handleMouseMove}
        onTouchEnd={handleMouseLeave}
        onTouchCancel={handleMouseLeave}
      >
        {children}
      </div>
      <style className='hover will-change-transform'></style>
    </>
  );
};

export default CardHoloEffect;

// <img
//   src='https://phombet.com/_next/image?url=https%3A%2F%2Fp002-fe.d002d.com%2Fstatic%2F2024%2F03%2FBUFFALO-WIN.png&w=640&q=75'
//   alt=''
// />

// <style className='hover'></style>
